<template>
  <b-field
    :label="label"
    :type="{ 'is-danger': $parent.$parent.errors.has(name) }"
    :message="$parent.$parent.errors.first(this.name)"
  >
    <slot />
  </b-field>
</template>
<script>
export default {
  name: 'FormItem',
  inject: ['$validator'],
  data () {
    return {
      name: null
    }
  },
  mounted () {
    this.name = this.$children[0].$children[0].$attrs.name
  },
  computed: {
    label () {
      if (!this.name) return ''
      return this.$t(`validation.attributes.${this.name}`)
    }
  },
  updated () {
    this.name = this.$children[0].$children[0].$attrs.name
  }
}
</script>
